import { heroImages } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={heroImages.heroBg}
        alt="Pandabuy spreadsheet curated fashion finds collection"
        title="PandabuySpreadsheet – Best Updated Pandabuy Spreadsheet Hub"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-4 md:mb-6">
            Pandabuy<span className="text-primary-300">Spreadsheet</span> Hub
          </h1>
          <p className="text-sm md:text-lg text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 font-light leading-relaxed">
            Discover the most updated pandabuyspreadsheet lists, curated fashion finds, and high-quality products across sneakers, clothing, and lifestyle categories — updated weekly for the community.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold font-label bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Pandabuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold font-label bg-white/95 text-foreground-950 rounded-lg hover:bg-white transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex items-center justify-center gap-6 mt-8 text-xs text-white/70 font-label">
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line"></i> Updated Weekly
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-double-line"></i> Community Verified
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-layout-grid-line"></i> 10+ Guides
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}